import { useEffect, useState } from "react";
import { recentTrash, restoreTrash } from "../storage/trash";
export function TrashPanel({
	onRestored,
}: {
	onRestored: () => Promise<void>;
}) {
	const [rows, setRows] = useState<Awaited<ReturnType<typeof recentTrash>>>([]),
		[error, setError] = useState("");
	useEffect(() => {
		recentTrash()
			.then(setRows)
			.catch(() => setError("최근 지운 여행을 읽지 못했어요."));
	}, []);
	return (
		<details className="workspace-disclosure">
			<summary>최근 지운 여행 · 7일 동안 복구</summary>
			{rows.length === 0 ? (
				<p>최근 지운 여행이 없어요.</p>
			) : (
				rows.map((row) => (
					<article key={row.id}>
						<strong>{row.trip.title}</strong>
						<button
							type="button"
							className="button secondary"
							onClick={async () => {
								try {
									await restoreTrash(row.id);
									setRows(await recentTrash());
									await onRestored();
								} catch {
									setError(
										"복구하지 못했어요. 같은 여행이 이미 있는지와 저장 공간을 확인해 주세요.",
									);
								}
							}}
						>
							되살리기
						</button>
					</article>
				))
			)}
			{error && <p role="alert">{error}</p>}
		</details>
	);
}
